import type { FaireProductEntity } from "../../entity_types/product";

export const p_sejqps7khh: FaireProductEntity = {
  token: "p_sejqps7khh",
  type: "product",
  name: "18K STAINLESS STEEL CORDED CHARM NECKLACE | 40NK9554",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/0427c8ba3b83eff59e482ee84da3ecf7cade2ad93997f140386dd078defd5450.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3d4b139494e6585f964390f494594aeca5790606b13f193feaca58e0be7f74cf.jpeg",
    "https://cdn.faire.com/fastly/d1db2aa369463ce40d3c870f0da494b6da650663dc61400f1f1af692ead377b4.jpeg",
    "https://cdn.faire.com/fastly/1243e9d99a3551c2900e11f0ccc6e60cb6f21aebfcead9fb5990eccb04561a91.jpeg",
    "https://cdn.faire.com/fastly/ce58167e3fbe5e25c081aa6bed85f3d898cf15f5f6c02c137c0f732ed4d06058.jpeg",
    "https://cdn.faire.com/fastly/32f20c6bf108f4b26cd8e094e720d9feb0b43b99c4a468fc1b1dc267fdbc8f0d.jpeg",
    "https://cdn.faire.com/fastly/eca27e43fff0c93bc352890a0d06056fb1fa568906886e1646efacec4e42495e.jpeg",
    "https://cdn.faire.com/fastly/c65e10dda6b5ac0574c68ee64a0ff06575e2c82dffe3e9e3aa4b118feeaf1656.jpeg",
  ],
  priceDollars: 8.24,
  description:
    '18K Stainless Steel Tarnish-Free Charm Necklace with Rope Chain with multi charms.  Charm Necklace, featuring multi charms of cherry, ocean, coin, floral, fish on a fashionable rope chain adorned with an array of exquisite charms.   Its tarnish-free design ensures long-lasting shine and resilience, the bracelet is hypoallergenic, waterproof, fade-resistant, and tarnish-free. \n\nProduct Details:\nlength: 16"\nCharm size: .25" - .5"\next: 2" ext\nclasp: Lobster Claw\nMetal finish: Stainless Steel 18K Gold \nproduct: Lead & Nickel Compliant\nanti-tarnish:  Tarnish Free, Non-Tarnish\n\nReal Gold Dipped Necklace\nStainless Steel Necklace\nHypoallergenic Necklace\nTarnish-Free Necklace \nNon-Tarnish Necklace\nWaterproof Necklace\nWater Resistant Necklace\nSweatproof Jewelry\nFade Resistant Necklace\nAnti-oxidation \nLasting Shine ',
  tags: [],
  msrpDollars: 16.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:57.036Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
